<script>
// import Boutton from '../../../component/helper/add/button.vue';
import allRequest from "./allRequest.vue";

export default {
  components: {
    allRequest,
    // Boutton,
  },
  data() {
    return {
      createNewService: false,
      isLoading: false,
    };
  },
  methods: {}
}
</script>

<template>
  <div class="p-6 all">
    <div class="begin">
      <div
        class="content"
      >
        <div class="header flex items-center justify-between mb-12">
          <div class="w-2/3 font-c7 text-left text-c34 2xl:text-c42 text-black">
            Demandes de services
          </div>
          <!-- <div>
            <Boutton
              label="Ajouter un service"
              weight="500"
              background="#241A72"
              padding="8px 38px"
              size="16"
              @click="createNewService = true"
            />
          </div> -->
        </div>
        <div class="body">
          <div class="bg-white w-full rounded-10 p-5 min-h-screen">
            <allRequest />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@media (max-width: 1024px) {
  .all {
    padding: 10px;
  }
}
</style>
